import { createSlice } from "@reduxjs/toolkit";
import { fetchRacksList, createOrUpdateRack, deleteRack } from "./racksThunks";

const racksSlice = createSlice({
  name: "racks",
  initialState: {
    racks: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedRack: null,
    isEditRack: false,
  },
  reducers: {
    resetRackManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedRack: (state, action) => {
      state.selectedRack = action.payload;
    },
    setIsEditRack: (state, action) => {
      state.isEditRack = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRacksList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRacksList.fulfilled, (state, action) => {
        state.loading = false;
        state.racks = action.payload;
      })
      .addCase(createOrUpdateRack.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteRack.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const { resetRackManageStatus, setSelectedRack, setIsEditRack } =
  racksSlice.actions;
export default racksSlice.reducer;
